import { CircularProgress, Box, Typography, keyframes } from "@mui/material"
import React from "react"

const pulse = keyframes`
  0% { opacity: 0.6; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1.02); }
  100% { opacity: 0.6; transform: scale(0.98); }
`

const Loading = ({ message = "در حال انجام عملیات ..." }) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      width='100%'
      sx={{
        animation: `${pulse} 2s ease-in-out infinite`
      }}
    >
      <CircularProgress
        size={64}
        thickness={2}
        color='primary'
        sx={{
          mb: 3,
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round"
          }
        }}
      />

      <Typography variant='h5' fontWeight={500} color='text.secondary' gutterBottom>
        {message}
      </Typography>

      <Typography variant='body2' color='gray.500'>
        لطفا صبر کنید...
      </Typography>
    </Box>
  )
}

export default Loading
